import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule, NgClass} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  selector: 'app-dialog-button',
  template: `
    <app-base-button
      [baseClass]="['px-4', 'py-2', 'border', 'rounded-xl', customClass, variantClasses].join(' ')"
      [disabled]="disabled"
      (onClick)="onClick.emit($event)"
      stateColorScheme="surface"
    >
      <div class="flex justify-center w-full items-center">
        <span class="text-center">{{ text }}</span>
      </div>
    </app-base-button>
  `
})
export class DialogButtonComponent {
  @Input() text: string = 'Action';
  @Input() variant: 'default' | 'primary' | 'warning' = 'default';
  @Input() disabled: boolean = false;
  @Input() customClass: string = '';
  @Output() onClick = new EventEmitter<MouseEvent>();

  get variantClasses(): string {
      switch (this.variant) {
        case 'primary':
          return 'bg-theme-primary text-theme-contrast hover:bg-theme-primary/90';
        case 'warning':
          return 'bg-theme-warning text-white hover:bg-theme-warning/90';
        default:
          return 'hover:bg-theme-surface2';
      }
  }
}
